import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { bindActionCreators } from "redux";
import { reduxForm, getFormValues } from "redux-form";
import {
  ChevronRightIcon,
  TicketIcon,
  CreditCardIcon,
  UserIcon,
  CalendarDaysIcon,
  XMarkIcon,
} from "@heroicons/react/24/solid";
import { TicketIcon as TicketIconOutline } from "@heroicons/react/24/outline";
import _ from "lodash";
import toast from "react-hot-toast";
import {
  clearTickets,
  fetchTickets,
  fetchEventUserCategories,
  manageTicketCount,
  cancelPromo,
  updateTicketAssignedAttendee,
  updateTicketAssignedError,
  palceTicketOrder,
  clearOrderData,
  updateAssignFlow,
} from "@ticketsaction";
import {
  fetchStripeCharges,
  fetchStripeConnection,
  fetchEventInterests,
  fetchAppuserCount,
} from "@mainaction";
import { classNames, validateEmail, validateUrl } from "@utilscommon";
import { EVENTIFY_FEE, STRIPE_FEE, STRIPE_FEE_EXTRA } from "@constant";
import CurrencyOptions from "./components/currency-option";
import TicketTags from "./components/ticket-tags";
import TicketList from "./components/tickets-list";
import AssignTickets from "./components/assign-tickets";
import AssignRSVPSessions from "./components/assign-rsvp-sessions";
import BuyerInfo from "./components/buyer-info";
import TicketOrderDetails from "./components/ticket-order-transaction-details";
import Loader from "@loader";
import LocaleStrings from "@language";
import ExpressLogin from "../social-promotion/express-login";
import {
  useLocalStorage,
  LOCAL_STORAGE,
  LOGIN_SCREEN_NAME,
} from "@useLocalStorage";
import usePostAnalytics from "@usePostAnalytics";

const Tickets = (props) => {
  const { getLocalStorage } = useLocalStorage();
  const navigate = useNavigate();
  const location = useLocation();
  const { ticketcode, source } = useParams();
  const {
    session,
    eventData,
    eventSettingsData,
    ticketArray,
    stripeCharges,
    manageTicketsCount,
    promoApplied,
    pristine,
    invalid,
    submitting,
    formValues,
    assignedAttendeeTickets,
    pResponseData,
    assignflow,
    clientbuildno,
    updateAssignFlow,
  } = props;
  const [ticketNav, setTicketNav] = useState({
    current: "ticket",
    flow: [
      {
        key: "ticket",
        label: LocaleStrings.kSelectTicketsText,
        icon: <TicketIcon className="w-6 h-6 rotate-135" />,
        status: "current",
      },
      {
        key: "payment",
        label: LocaleStrings.kPaymentDetailsText,
        icon: <CreditCardIcon className="w-6 h-6" />,
        status: "",
      },
      {
        key: "assignment",
        label: LocaleStrings.kAssignAttendeesText,
        icon: <UserIcon className="w-6 h-6" />,
        status: "",
      },
    ],
  });
  const [sessioncall, setsessioncall] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [displayTagsFirst, setDisplayTagsFirst] = useState(false);
  const [selectedTag, setSelectedTag] = useState("");
  const [eventifyFee, setEventifyFee] = useState(EVENTIFY_FEE);
  const [stripeFee, setStripeFee] = useState(STRIPE_FEE);
  const [stripeFixedFee, setStripeFixedFee] = useState(STRIPE_FEE_EXTRA);
  const [loading, setLoading] = useState(false);
  const [selfAssign, setSelfAssign] = useState(false);
  const [orderAction, setOrderAction] = useState("");
  const [disableFields, setDisableFields] = useState(false);
  const [onlinePaymentKeys, setOnlinePaymentKeys] = useState({});
  const [orderErrorMessage, setOrderErrorMessage] = useState("");
  const [assignedFormHasError, setAssignedFormHasError] = useState(false);
  const [prid, setPRID] = useState("");
  const [prepromo, setPrePromo] = useState("");
  const alertRef = useRef(null);
  let callFrom = "";
  if (
    (ticketcode && ticketcode.toLowerCase() === "admin") ||
    (source && source.toLowerCase() === "admin")
  ) {
    callFrom = "admin";
  }
  const socialDetails = getLocalStorage(LOCAL_STORAGE.USER_SOCIAL_DETAILS);
  const loginScreen = getLocalStorage(LOCAL_STORAGE.LOGIN_SCREEN);
  const postAffiliationAnalytics = usePostAnalytics(session);

  useEffect(() => {
    clearTicketData(); // Clear the ticket old data and load new

    let data = { eventid: eventData?.eventid };
    if (ticketcode && ticketcode.toLowerCase() !== "admin") {
      data.ticketcode = ticketcode;
    }
    if (callFrom === "admin") {
      data.source = "admin";
    }

    let param = new URLSearchParams(location.search);

    // If proposal ticket, then get the proposal response id
    let PRID = param.get("proposal");
    // console.log("PRID :- ", PRID);
    if (PRID) {
      data.prid = PRID;
      setPRID(PRID);
    }

    // If proposal ticket, then get the proposal response id
    let PROMOCODE = param.get("promo");
    // console.log("PROMOCODE :- ", PROMOCODE);
    if (PROMOCODE) {
      data.promo = PROMOCODE.toString().trim();
      setPrePromo(PROMOCODE.toString().trim());
    }

    if (eventSettingsData?.data?.islive) {
      // Change the nav bar as per ticket assign flow
      if (
        (clientbuildno > 6
          ? assignflow
          : eventSettingsData?.data?.ticketassignflow) === "beforepayment"
      ) {
        props.fetchEventInterests(session, () => {});

        setTicketNav({
          current: "ticket",
          flow: [
            {
              key: "ticket",
              label: LocaleStrings.kSelectTicketsText,
              icon: <TicketIcon className="w-6 h-6 rotate-135" />,
              status: "current",
            },
            {
              key: "assignment",
              label: LocaleStrings.kAssignAttendeesText,
              icon: <UserIcon className="w-6 h-6" />,
              status: "",
            },
            {
              key: "payment",
              label: LocaleStrings.kPaymentDetailsText,
              icon: <CreditCardIcon className="w-6 h-6" />,
              status: "",
            },
          ],
        });
      }

      if (
        eventSettingsData?.data?.eventcapacity > 0 &&
        eventSettingsData?.data?.waitlistmode === false
      ) {
        props.fetchAppuserCount(session, data, () => {});
      }

      props.fetchEventUserCategories(session, () => {});

      props.fetchTickets(session, data, (res) => {
        // console.log("data :- ", res);

        if (data?.ticketcode && res?.data?.length === 1) {
          let trackingpixel = res?.data?.[0]?.trackingpixel ?? "";
          // console.log("trackingpixel :- ", trackingpixel);

          if (trackingpixel && trackingpixel !== "") {
            let local_trackingpixel = JSON.parse(trackingpixel);
            let trackingpixel_header = local_trackingpixel?.header ?? "";
            let trackingpixel_footer = local_trackingpixel?.footer ?? "";

            if (trackingpixel_header !== "") {
              let head = document.querySelector("head");
              let innerScript = document
                .createRange()
                .createContextualFragment(trackingpixel_header);
              head.appendChild(innerScript);
            }
            if (trackingpixel_footer !== "") {
              let body = document.querySelector("body");
              let innerScript = document
                .createRange()
                .createContextualFragment(trackingpixel_footer);
              body.appendChild(innerScript);
            }
          }
          // logic to append tracking script //
        }

        if (res?.currency?.length > 0) {
          let currency = res?.currency?.[0];
          setSelectedCurrency(currency);
          props.fetchStripeCharges(session, (res1) => {
            if (res1?.data?.length > 0) {
              let match = _.filter(res1?.data, (o) => o.currency === currency);

              if (match?.length > 0) {
                setEventifyFee(match?.[0]?.application_fee);
                setStripeFee(match?.[0]?.stripe_percentage);
                setStripeFixedFee(match?.[0]?.stripe_fixed);
              }
            }
          });
        }
      });

      if (!ticketcode)
        setDisplayTagsFirst(
          eventData?.eventsettings_by_eventid?.[0]?.allowgroupticket ?? false
        );
    }

    props.fetchStripeConnection(session, () => {});
  }, [eventData?.eventid, ticketcode, callFrom]);
  let ticketAssignFlow =
    clientbuildno < 7 ? eventSettingsData?.data?.ticketassignflow ?? "" : ""; // Ticket assign flow

  useEffect(() => {
    // storing all selected ticket  assignment means beforepayment or afterpayemnt
    if (clientbuildno > 6) {
      let assignarray = [];
      let genralarray = [];
      //console.log("update", manageTicketsCount);
      _.map(manageTicketsCount, (item) => {
        assignarray.push(item?.ticketassignflow);
        if (item?.type !== "addon") {
          genralarray.push(item?.ticketassignflow);
        }
      });
      let availableForSelfAssign = false;

      let groupTicketsArr = _.filter(manageTicketsCount, (o) => {
        return o?.noofchildtickets;
      });
      let generalTicketsArr = _.filter(manageTicketsCount, (o) => {
        return o?.type !== "addon";
      });
      let totalGeneralTickets = _.sumBy(generalTicketsArr, function (o) {
        return o?.quantity;
      });
      let addonTicketsArr = _.filter(manageTicketsCount, (o) => {
        return o?.type === "addon";
      });
      let totalAddonTickets = _.sumBy(addonTicketsArr, function (o) {
        return o?.quantity;
      });
      // checking for selfassign means one general ticket with one or more addon ticket
      if (
        groupTicketsArr?.length === 0 &&
        totalGeneralTickets === 1 &&
        totalAddonTickets > 0
      ) {
        availableForSelfAssign = true;
      }
      // console.log({ availableForSelfAssign });
      // if any ticket content beforepayment and one general ticket with one or more addon ticket logic not a then flow is before
      // else after assign

      if (
        (assignarray.includes("beforepayment") && !availableForSelfAssign) ||
        (availableForSelfAssign && genralarray.includes("beforepayment"))
      ) {
        updateAssignFlow("beforepayment");

        setTicketNav({
          current: "ticket",
          flow: [
            {
              key: "ticket",
              label: LocaleStrings.kSelectTicketsText,
              icon: <TicketIcon className="w-6 h-6 rotate-135" />,
              status: "current",
            },
            {
              key: "assignment",
              label: LocaleStrings.kAssignAttendeesText,
              icon: <UserIcon className="w-6 h-6" />,
              status: "",
            },
            ...(sessioncall
              ? [
                  {
                    key: "session",
                    label: LocaleStrings.kSessionRSVPSectionTitle,
                    icon: <CalendarDaysIcon className="w-6 h-6" />,
                    status: "",
                  },
                ]
              : []),
            {
              key: "payment",
              label: LocaleStrings.kPaymentDetailsText,
              icon: <CreditCardIcon className="w-6 h-6" />,
              status: "",
            },
          ],
        });
      }
      // after assign logic
      else {
        updateAssignFlow("afterpayment");
        setTicketNav({
          current: "ticket",
          flow: [
            {
              key: "ticket",
              label: LocaleStrings.kSelectTicketsText,
              icon: <TicketIcon className="w-6 h-6 rotate-135" />,
              status: "current",
            },

            {
              key: "payment",
              label: LocaleStrings.kPaymentDetailsText,
              icon: <CreditCardIcon className="w-6 h-6" />,
              status: "",
            },
            {
              key: "assignment",
              label: LocaleStrings.kAssignAttendeesText,
              icon: <UserIcon className="w-6 h-6" />,
              status: "",
            },
          ],
        });
      }
    }
  }, [manageTicketsCount]);

  const clearTicketData = () => {
    // Clear the ticket list, then load new
    props.clearTickets({});

    // Clear the selected ticket
    props.manageTicketCount([]);

    // Clear the promo code
    props.cancelPromo({});

    // Clear the assigned attendee data
    props.updateTicketAssignedAttendee({});
    props.updateTicketAssignedError({});

    // Clear Previous Order details
    props.clearOrderData();
  };

  const onSubmitForm = (data) => {
    // console.log("data :- ", data);

    let ticketdata = [];
    _.forEach(manageTicketsCount, (item) => {
      ticketdata.push({
        ticketid: item.ticketid,
        quantity: item.quantity,
        price: item.price,
      });
    });
    let checkHasChild = _.filter(manageTicketsCount, (obj) => obj?.haschild); // Check any associated child ticket available in order

    let values = { ...data };
    values.eventid = eventData?.eventid;
    values.assign_himself = data?.assign_himself ?? false;
    values.tickets = ticketdata;
    values.promocode = _.isEmpty(promoApplied) ? "" : promoApplied?.promocode;
    if (!data?.isinvoice) {
      values.isinvoice = false;
      values.vat = "";
      values.street = "";
      values.city = "";
      values.postal = "";
      values.country = "";

      if (checkHasChild.length === 0) {
        values.company_name = "";
      }
    }

    if (
      (clientbuildno > 6 ? assignflow : ticketAssignFlow) === "beforepayment"
    ) {
      values.assignedAttendees = assignedAttendeeTickets;
    }
    if (prid !== "") {
      values.prid = prid;
    }
    // console.log("final value :- ", values);

    // Get external thankyou page
    let thankYouLink = "";
    if (
      eventSettingsData?.data?.thankyoulink &&
      eventSettingsData?.data?.thankyoulink !== ""
    ) {
      let linkVal = eventSettingsData?.data?.thankyoulink;
      if (validateUrl(linkVal)) {
        if (linkVal.search("http") === -1) {
          thankYouLink = `http://${linkVal}`;
        } else {
          thankYouLink = linkVal;
        }
      }
    }

    // Get external offline thankyou page
    let offlineThankYouLink = "";
    if (
      eventSettingsData?.data?.offlinecongratulations &&
      eventSettingsData?.data?.offlinecongratulations !== ""
    ) {
      let linkVal = eventSettingsData?.data?.offlinecongratulations;
      if (validateUrl(linkVal)) {
        if (linkVal.search("http") === -1) {
          offlineThankYouLink = `http://${linkVal}`;
        } else {
          offlineThankYouLink = linkVal;
        }
      }
    }
    let param = location.search;

    setOrderErrorMessage("");
    setOrderAction(data?.type);
    setLoading(true);
    setDisableFields(true);
    props.palceTicketOrder(session, values, (response) => {
      // console.log("response order :- ", response);

      setLoading(false);
      setOrderAction("");
      if (response.success === 1) {
        if (data?.type === "payment_intent") {
          setOnlinePaymentKeys({
            ...(response?.data ?? {}),
            gateway: response?.data?.gateway,
            id: response?.data?.transactionId,
            secret: response?.data?.clientSecret,
          });
        } else if (data?.type === "freepayment") {
          setDisableFields(false);
          thankYouLink !== ""
            ? (window.location.href = thankYouLink)
            : navigate(
                `/tickets/ticketorder/${response?.data?.ordernumber}${param}`,
                {
                  state: { ...(response?.data ?? {}) },
                }
              );
        } else if (data?.type === "paylater") {
          offlineThankYouLink !== ""
            ? (window.location.href = offlineThankYouLink)
            : navigate(
                `/tickets/ticketorder/${response?.data?.ordernumber}${param}`,
                {
                  state: { ...(response?.data ?? {}) },
                }
              );
        } else {
          thankYouLink !== ""
            ? (window.location.href = thankYouLink)
            : navigate(
                `/tickets/ticketorder/${response?.data?.ordernumber}${param}`,
                {
                  state: { ...(response?.data ?? {}) },
                }
              );
        }
        postAffiliationAnalytics("redemption");
      } else if (response.success === 2) {
        setDisableFields(false);
        if (response?.data?.code === "name_required") {
          setOrderErrorMessage(LocaleStrings.kBuyerNameRequiredText);
        } else if (response?.data?.code === "email_required") {
          setOrderErrorMessage(LocaleStrings.kBuyerEmailRequiredText);
        } else if (response?.data?.code === "invalid_email") {
          setOrderErrorMessage(LocaleStrings.kBuyerEmailInvalidText);
        } else if (response?.data?.code === "company_required") {
          setOrderErrorMessage(LocaleStrings.kBuyerCompanyRequiredText);
        } else if (response?.data?.code === "eventid_required") {
          setOrderErrorMessage(LocaleStrings.kEventidRequiredText);
        } else if (response?.data?.code === "amount_required") {
          setOrderErrorMessage(LocaleStrings.kTicketAmountRequiredText);
        } else if (response?.data?.code === "invalid_ticket_data") {
          setOrderErrorMessage(LocaleStrings.kInvalidTicketDataText);
        } else if (response?.data?.code === "currency_required") {
          setOrderErrorMessage(LocaleStrings.kCurrencyRequiredText);
        } else if (response?.data?.code === "currency_not_supportable") {
          setOrderErrorMessage(LocaleStrings.kCurrencyNotSupportableText);
        } else if (
          response?.data?.code === "buyer_additional_fields_required"
        ) {
          setOrderErrorMessage(LocaleStrings.kBuyerAdditionalInfoRequired);
        } else if (
          response?.data?.code === "promo_code_not_applicable_for_withoutpay"
        ) {
          setOrderErrorMessage(
            LocaleStrings.kPromoNotApplyOnWithoutPayTicketsText
          );
        } else if (response?.data?.code === "invalid_eventid") {
          setOrderErrorMessage(LocaleStrings.kInvalidEventText);
        } else if (response?.data?.code === "organizer_credit_limit_used") {
          let hostCredit = response?.data?.resource?.total_userlimit_credits;
          let usedCredit =
            response?.data?.resource?.total_userlimit_credits_used;
          let availableCredit =
            hostCredit > usedCredit ? hostCredit - usedCredit : 0;

          setOrderErrorMessage(
            availableCredit > 0
              ? _.replace(
                  LocaleStrings.kHostCreditLimitLeftText,
                  /###LEFTQUANTITY###/g,
                  availableCredit
                )
              : LocaleStrings.kHostCreditLimitUsedText
          );
        } else if (response?.data?.code === "event_capacity_full") {
          setOrderErrorMessage(
            response?.data?.resource?.leftseat > 0
              ? _.replace(
                  LocaleStrings.kEventCapacityLeftText,
                  /#leftquantity/g,
                  response?.data?.resource?.leftseat
                )
              : LocaleStrings.kEventCapacityFullTicketText
          );
        } else if (response?.data?.code === "event_registration_date_fail") {
          toast.error(LocaleStrings.kEventRegDateFailText);
        } else if (response?.data?.code === "email_domain_not_allowed") {
          setOrderErrorMessage(
            _.replace(
              LocaleStrings.kInvalidEmailDomainText,
              "###DOMAIN###",
              response?.data?.resource?.domain
            )
          );
        } else if (response?.data?.code === "email_already_in_use") {
          setOrderErrorMessage(LocaleStrings.kEmailAlreadyRegisteredText);
        } else if (
          response?.data?.code ===
          "assigned_attendee_email_not_associated_with_event"
        ) {
          setOrderErrorMessage(
            _.replace(
              LocaleStrings.kAssignedUsersNotRegisteredText,
              "#emails",
              response?.data?.resource?.emails
            )
          );
        } else if (
          response?.data?.code === "self_assigned_attendee_emails_not_similar"
        ) {
          setOrderErrorMessage(
            _.replace(
              LocaleStrings.kAssignedUsersNotSimilarText,
              "#emails",
              response?.data?.resource?.emails
            )
          );
        } else if (
          response?.data?.code === "assigned_attendee_email_already_in_use"
        ) {
          setOrderErrorMessage(
            _.replace(
              LocaleStrings.kAssignedUsersAlreadyRegisteredText,
              "#emails",
              response?.data?.resource?.emails
            )
          );
        } else if (
          response?.data?.code ===
          "assigned_attendee_have_other_access_permission"
        ) {
          setOrderErrorMessage(
            _.replace(
              LocaleStrings.kAssignedUsersHaveOthersAccessPermissionText,
              "#emails",
              response?.data?.resource?.emails
            )
          );
        } else if (
          response?.data?.code ===
          "assigned_attendee_already_assigned_with_current_ticket"
        ) {
          setOrderErrorMessage(
            _.replace(
              LocaleStrings.kAssignedUsersAlreadyHaveCurrentTicketAccessText,
              "#emails",
              response?.data?.resource?.emails
            )
          );
        } else if (response?.data?.code === "invalid_assigned_attendee_data") {
          setOrderErrorMessage(LocaleStrings.kFillAllAttendeeDetailsText);
        } else if (
          response?.data?.code === "duplicate_attendee_email_in_same_ticket"
        ) {
          let mapObj = {
            "#emails": response?.data?.resource?.emails,
            "#tickets": response?.data?.resource?.ticketname,
          };
          let message = LocaleStrings.kAssignedUsersDuplicateText.replace(
            /#emails|#tickets/gi,
            function (matched) {
              return mapObj[matched];
            }
          );
          setOrderErrorMessage(message);
        } else if (
          response?.data?.code === "duplicate_attendee_email_in_other_ticket"
        ) {
          let mapObj = {
            "#emails": response?.data?.resource?.emails,
            "#tickets": response?.data?.resource?.ticketname,
          };
          let message = LocaleStrings.kAssignedUsersDuplicateText.replace(
            /#emails|#tickets/gi,
            function (matched) {
              return mapObj[matched];
            }
          );
          setOrderErrorMessage(message);
        } else if (
          response?.data?.code === "assigned_attendee_email_domain_not_allowed"
        ) {
          setOrderErrorMessage(
            _.replace(
              LocaleStrings.kAssignedEmailInvalidDomainText,
              "###DOMAIN###",
              response?.data?.resource?.domains
            )
          );
        } else if (
          response?.data?.code === "invalid_assigned_attendee_emails"
        ) {
          setOrderErrorMessage(
            _.replace(
              LocaleStrings.kAssignedUsersEmailInvalidText,
              "#emails",
              response?.data?.resource?.emails
            )
          );
        } else if (response?.data?.code === "invalid_assigned_ticket_data") {
          setOrderErrorMessage(
            _.replace(
              LocaleStrings.kAssignedUsersTicketInvalidText,
              "#ticketid",
              response?.data?.resource?.ticketid
            )
          );
        } else if (response?.data?.code === "session_seat_full") {
          let mapObj = {
            "#sessions": response?.data?.resource?.sessions,
            "#emails": response?.data?.resource?.emails,
          };
          let message =
            LocaleStrings.kAssignedUsersSessionCapacityFullText.replace(
              /#sessions|#emails/gi,
              function (matched) {
                return mapObj[matched];
              }
            );
          setOrderErrorMessage(message);
        } else if (
          response?.data?.code ===
          "same_track_multiple_session_rsvp_not_allowed"
        ) {
          setOrderErrorMessage(
            _.replace(
              LocaleStrings.kSameTrackSessionRSVPNotAllowedText,
              "#sessions",
              response?.data?.resource?.sessions
            )
          );
        } else if (
          response?.data?.code === "common_time_session_rsvp_not_allowed"
        ) {
          let mapObj = {
            "#sessions": response?.data?.resource?.sessions,
            "#emails": response?.data?.resource?.emails,
          };
          let message =
            LocaleStrings.kAssignedUsersSessionRSVPNotAllowedCommonTimeText.replace(
              /#sessions|#emails/gi,
              function (matched) {
                return mapObj[matched];
              }
            );
          setOrderErrorMessage(message);
        } else if (
          response?.data?.code === "user_have_other_access_permission"
        ) {
          setOrderErrorMessage(
            LocaleStrings.kUserHaveOtherAccessPermissionText
          );
        } else if (
          response?.data?.code === "email_already_assigned_with_current_ticket"
        ) {
          setOrderErrorMessage(
            LocaleStrings.kEmailAlreadyHaveCurrentTicketAccessText
          );
        } else if (response?.data?.code === "email_not_associated_with_event") {
          setOrderErrorMessage(LocaleStrings.kThisEmailNotRegistered);
        } else if (response?.data?.code === "minimum_ticket") {
          let mapObj = {
            "#min": response?.data?.resource?.min_quantity,
            "#ticketname": response?.data?.resource?.ticketname,
          };
          let message = LocaleStrings.kTicketMinQtyText.replace(
            /#min|#ticketname/gi,
            function (matched) {
              return mapObj[matched];
            }
          );

          setOrderErrorMessage(message);
        } else if (response?.data?.code === "maximum_ticket") {
          let mapObj = {
            "#max": response?.data?.resource?.max_quantity,
            "#ticketname": response?.data?.resource?.ticketname,
          };
          let message = LocaleStrings.kTicketMaxQtyText.replace(
            /#max|#ticketname/gi,
            function (matched) {
              return mapObj[matched];
            }
          );

          setOrderErrorMessage(message);
        } else if (response?.data?.code === "left_quantity") {
          let mapObj = {
            "#remain": response?.data?.resource?.left_quantity,
            "#ticketname": response?.data?.resource?.ticketname,
          };
          let message = LocaleStrings.kTicketRemainQtyText.replace(
            /#remain|#ticketname/gi,
            function (matched) {
              return mapObj[matched];
            }
          );

          setOrderErrorMessage(message);
        } else if (response?.data?.code === "invalid_promocode") {
          setOrderErrorMessage(LocaleStrings.kInvalidPromoText);
        } else if (response?.data?.code === "promo_expired") {
          setOrderErrorMessage(LocaleStrings.kPromoExpiredText);
        } else if (response?.data?.code === "promo_limit_exceeded") {
          setOrderErrorMessage(LocaleStrings.kPromoLimitExceededText);
        } else if (response?.data?.code === "promo_amount_greater") {
          setOrderErrorMessage(
            LocaleStrings.kPromoAmountGreaterThanTicketAmountText
          );
        } else if (response?.data?.code === "total_amount_incorrect") {
          setOrderErrorMessage(LocaleStrings.kTotalAmountIncorrectText);
        } else if (response?.data?.code === "stripe_account_not_connected") {
          setOrderErrorMessage(LocaleStrings.kStripeNotConnectedText);
        } else if (response?.data?.code === "order_not_created") {
          setOrderErrorMessage(LocaleStrings.kOrderNotCreatedText);
        } else if (response?.data?.code === "invalid_proposal_responseid") {
          setOrderErrorMessage(LocaleStrings.kInvalidAbstractResIdText);
        } else if (response?.data?.code === "only_one_ticket_allow") {
          setOrderErrorMessage(LocaleStrings.kOnly1TicketBuyText);
        } else if (response?.data?.code === "session_overlaping_error") {
          setOrderErrorMessage(LocaleStrings.KSessionOverLapText);
        } else if (
          response?.data?.code === "invalid_eventify_payment_gateway_accountid"
        ) {
          setOrderErrorMessage(
            LocaleStrings.kInvalidEventifyPaymentGatewayAccountText
          );
        } else if (
          response?.data?.code === "currency_not_supportable_razorpay"
        ) {
          setOrderErrorMessage(LocaleStrings.kCurrencyNotSupportableText);
        } else if (response?.data?.code === "purchase_limit_exceeded") {
          setOrderErrorMessage(LocaleStrings.kPurchaseLimitText);
        } else {
          setOrderErrorMessage(LocaleStrings.kSomethingWentWrongMsg);
        }
      } else {
        setDisableFields(false);
        toast.error(LocaleStrings.kSomethingWentWrongMsg);
      }
    });
  };

  const handleNavWithSession = (action, assignflow) => {
    // console.log("update2", action);
    // console.log({ assignflow });
    if (
      clientbuildno > 6
        ? assignflow === "beforepayment" && action === "addsessiontab"
        : ticketAssignFlow === "beforepayment"
    ) {
      // console.log("sucess");
      if (clientbuildno > 6) {
        // setsessioncall(true);
      }
      // console.log("hi");
      setTimeout(() => {
        setTicketNav({
          current: "ticket",
          flow: [
            {
              key: "ticket",
              label: LocaleStrings.kSelectTicketsText,
              icon: <TicketIcon className="w-6 h-6 rotate-135" />,
              status: "current",
            },
            {
              key: "assignment",
              label: LocaleStrings.kAssignAttendeesText,
              icon: <UserIcon className="w-6 h-6" />,
              status: "",
            },
            ...(action === "addsessiontab"
              ? [
                  {
                    key: "session",
                    label: LocaleStrings.kSessionRSVPSectionTitle,
                    icon: <CalendarDaysIcon className="w-6 h-6" />,
                    status: "",
                  },
                ]
              : []),
            {
              key: "payment",
              label: LocaleStrings.kPaymentDetailsText,
              icon: <CreditCardIcon className="w-6 h-6" />,
              status: "",
            },
          ],
        });
      }, 10);
    } else {
      if (clientbuildno > 6) {
        // setsessioncall(false);
      }
    }
  };

  const handleCurrency = (cur) => {
    setSelectedCurrency(cur);

    let match = _.filter(stripeCharges?.data, (o) => o.currency === cur);
    if (match?.length > 0) {
      setEventifyFee(match?.[0]?.application_fee);
      setStripeFee(match?.[0]?.stripe_percentage);
      setStripeFixedFee(match?.[0]?.stripe_fixed);
    }

    // Clear the selected ticket, if currency changed
    props.manageTicketCount([]);

    // Clear the promo code, if currency changed
    props.cancelPromo({});
  };

  const handleSelectTag = (tag) => {
    setSelectedTag(tag);

    setDisplayTagsFirst(false); // Now display the selected tag's ticket
  };

  const displaySelectTag = () => {
    setSelectedTag("");

    setDisplayTagsFirst(true); // Now display the selected tag's ticket
  };

  const expressCheckoutCompletion = (data = {}) => {
    if (
      _.isEmpty(data) &&
      !_.isEmpty(loginScreen) &&
      !_.isEmpty(socialDetails)
    ) {
      props.autofill("name", socialDetails?.username ?? "");
      props.autofill("email", socialDetails?.email ?? "");
    } else {
      props.autofill("name", data?.username ?? "");
      props.autofill("email", data?.email ?? "");
    }
  };

  const updateNav = (current = "") => {
    // console.log("current :- ", current);
    // console.log("manageTicketsCount :- ", manageTicketsCount);

    // Script to display or hide selfassign checkbox start
    let groupTicketsArr = _.filter(manageTicketsCount, (o) => {
      return o?.noofchildtickets;
    });
    let generalTicketsArr = _.filter(manageTicketsCount, (o) => {
      return o?.type !== "addon";
    });
    let totalGeneralTickets = _.sumBy(generalTicketsArr, function (o) {
      return o?.quantity;
    });
    let addonTicketsArr = _.filter(manageTicketsCount, (o) => {
      return o?.type === "addon";
    });
    let totalAddonTickets = _.sumBy(addonTicketsArr, function (o) {
      return o?.quantity;
    });
    // console.log({ assignflow, clientbuildno });

    if (
      (clientbuildno > 6 ? assignflow : ticketAssignFlow) === "beforepayment"
    ) {
      // console.log(groupTicketsArr, totalGeneralTickets);
      if (groupTicketsArr?.length === 0 && totalGeneralTickets === 1) {
        let gTId = generalTicketsArr?.[0]?.ticketid ?? 0;

        if (current === "payment") {
          let fname = assignedAttendeeTickets?.[gTId]?.[0]?.firstname ?? "";
          let lname = assignedAttendeeTickets?.[gTId]?.[0]?.lastname ?? "";
          let name = fname === "" ? `${lname}` : `${fname} ${lname}`;
          let email = assignedAttendeeTickets?.[gTId]?.[0]?.email ?? "";

          props.autofill("name", name);
          props.autofill("email", email);

          if (totalAddonTickets > 0) {
            setSelfAssign(false);
            props.autofill("assign_himself", true);
          }
        }
      } else if (!_.isEmpty(pResponseData)) {
        props.autofill(
          "name",
          formValues?.name ??
            pResponseData?.firstname + " " + pResponseData?.lastname
        );
        props.autofill("email", formValues?.email ?? pResponseData?.email);
      } else {
        setSelfAssign(false);
        props.autofill("assign_himself", false);
      }
    } else {
      if (totalGeneralTickets === 1 && groupTicketsArr?.length === 0) {
        setSelfAssign(true);
        props.autofill("assign_himself", true);
      } else if (totalGeneralTickets === 0 && totalAddonTickets > 0) {
        setSelfAssign(true);
        props.autofill("assign_himself", true);
      } else {
        setSelfAssign(false);
        props.autofill("assign_himself", false);
      }
    }
    if (_.isEmpty(formValues) || _.isEmpty(formValues?.name)) {
      expressCheckoutCompletion();
    }
    // Script to display or hide selfassign checkbox end

    let check = _.filter(ticketNav?.flow, (o) => o.key === current);
    let newNav = ticketNav?.flow;

    if (check?.length > 0) {
      let index = _.findIndex(newNav, (o) => o.key === current);
      _.forEach(newNav, (o, i) => {
        if (i < index) {
          o.status = "complete";
        } else if (i === index) {
          o.status = "current";
        } else {
          o.status = "";
        }
      });

      let obj = { current: current, flow: newNav };
      props.autofill("currentstep", current);
      setTicketNav(obj);
    }
  };

  const closeAlert = () => {
    alertRef.current.className = "hidden";
    setOrderErrorMessage("");
  };

  // This method is used for show form error at the time of continue button click
  const updateFormError = (bool) => {
    setAssignedFormHasError(bool);
  };

  const renderTicketFlow = () => {
    return _.map(ticketNav?.flow, (item, index) => {
      return (
        <div
          key={`ticket_flow${index}`}
          className="flex items-center space-x-3.5"
        >
          <div
            className={classNames(
              item.status === "complete"
                ? "text-theme cursor-pointer underline"
                : item.status === "current"
                ? "text-theme"
                : "text-secondary",
              `flow-progress-label ${item.key}-section`
            )}
            onClick={
              item.status === "complete" && !disableFields
                ? () => {
                    updateNav(item.key);
                  }
                : null
            }
          >
            {item.icon}
            <span className="flow-step hidden sm:block">{item.label}</span>
          </div>
          {ticketNav?.flow[index + 1] ? (
            <ChevronRightIcon className="w-5 h-5" />
          ) : (
            ""
          )}
        </div>
      );
    });
  };

  const renderOrderDetails = () => {
    return (
      <div id="scrollTracker" className="col-span-2 bg-gray-100 rounded-lg  ">
        <div id="stickyContent" className="p-6 bg-gray-100 ">
          <div className="mb-4">
            <div className="section-title">
              {LocaleStrings.kOrderSummaryText}
            </div>
          </div>

          {orderErrorMessage !== "" ? (
            <div ref={alertRef}>
              <div className="rounded-md bg-red-50 border border-red-200 p-4 mb-4">
                <div className="flex">
                  <p className="text-base font-normal text-customred">
                    {orderErrorMessage}
                  </p>

                  <div className="ml-auto pl-3">
                    <div className="-mx-1.5 -my-1.5">
                      <button
                        type="button"
                        className="inline-flex rounded-md bg-red-50 p-1.5 text-red-600 hover:bg-red-100 focus:outline-none"
                        onClick={closeAlert}
                      >
                        <span className="sr-only">Dismiss</span>
                        <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          {/* Ticket Order Details */}
          <TicketOrderDetails
            selectedCurrency={selectedCurrency}
            eventifyFee={eventifyFee}
            stripeFee={stripeFee}
            stripeFixedFee={stripeFixedFee}
            callFrom={callFrom}
            prepromo={prepromo}
            currentStep={currentStep}
            ticketNav={ticketNav}
            updateNav={updateNav}
            btnLoading={loading}
            orderAction={orderAction}
            onlinePaymentKeys={onlinePaymentKeys}
            updateFormHasError={updateFormError}
            pristine={pristine}
            invalid={invalid}
            submitting={submitting}
            formValues={formValues}
            formSubmit={onSubmitForm}
          />
        </div>
      </div>
    );
  };

  let isProposalTicket =
    !_.isEmpty(pResponseData) && assignflow !== "beforepayment";
  let currentStep = ticketNav?.current;
  // console.log("currentStep :- ", currentStep);
  // console.log("callFrom :- ", callFrom);
  // console.log("selectedCurrency :- ", selectedCurrency);
  // console.log("eventSettingsData :- ", eventSettingsData);
  // console.log("ticketArray :- ", ticketArray);
  // console.log("stripeCharges :- ", stripeCharges);
  // console.log("formValues :- ", formValues);
  // console.log("selectedTag :- ", selectedTag);
  // console.log("formHasError :- ", assignedFormHasError);

  let isSocialEnabled = false;
  if (eventSettingsData?.data) {
    const custom_settings = JSON.parse(eventSettingsData.data.custom_settings);
    isSocialEnabled =
      custom_settings?.socialboost_setting?.boostenabled ?? false;
  }

  const showExpresssLogin =
    loginScreen === LOGIN_SCREEN_NAME.PAYMENT_SCREEN &&
    _.isEmpty(socialDetails) &&
    !location?.pathname?.includes("ticketorder") &&
    isSocialEnabled;

  return (
    <>
      {eventSettingsData?.data ? (
        <>
          {eventSettingsData?.data?.islive ? (
            <>
              {ticketArray?.data ? (
                <>
                  {ticketArray?.data?.length > 0 ? (
                    <>
                      {displayTagsFirst &&
                      ticketArray?.tickettags?.length > 0 ? (
                        <div className="content-body">
                          <div className="mb-8 custom-text-secondary-md-bold">
                            {LocaleStrings.kTicketTagSelectDesc}
                          </div>
                          <TicketTags handleSelectTag={handleSelectTag} />
                        </div>
                      ) : (
                        <div className="min-h-inherit">
                          <div className="stap-box-container min-h-inherit">
                            <div className="stap-box-top ticket-flow-progress">
                              {renderTicketFlow()}
                            </div>

                            <div className="ticket-list-container">
                              {currentStep === "ticket" ? (
                                <div className="mx-auto md:grid grid-cols-5 min-h-inherit">
                                  <div
                                    id="firstColumn"
                                    className="col-span-3 p-6"
                                  >
                                    <div className="flex items-center justify-between mb-4">
                                      <div className="section-title">
                                        {LocaleStrings.kSelectTicketsText}
                                      </div>
                                      <div className="flex items-center space-x-2">
                                        {eventData
                                          ?.eventsettings_by_eventid?.[0]
                                          ?.allowgroupticket &&
                                        ticketArray?.tickettags?.length > 0 ? (
                                          <div
                                            className="custom-text-primary-sm-normal px-4 py-2 border border-default rounded-lg shadow-sm cursor-pointer"
                                            onClick={displaySelectTag}
                                          >
                                            {LocaleStrings.kShowTagsText}
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                        {ticketArray?.currency?.length > 1 ? (
                                          <div className="currency-display">
                                            <CurrencyOptions
                                              selectedCurrency={
                                                selectedCurrency
                                              }
                                              currencyChange={handleCurrency}
                                            />
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>

                                    {/* Ticket List */}
                                    <TicketList
                                      selectedCurrency={selectedCurrency}
                                      selectedTag={selectedTag}
                                      eventifyFee={eventifyFee}
                                      stripeFee={stripeFee}
                                      stripeFixedFee={stripeFixedFee}
                                      callFrom={callFrom}
                                      prepromo={prepromo}
                                      ticketNav={ticketNav}
                                      updateNavWithSession={
                                        handleNavWithSession
                                      }
                                    />
                                  </div>

                                  {renderOrderDetails()}
                                </div>
                              ) : currentStep === "assignment" ? (
                                <div className="mx-auto md:grid grid-cols-5 min-h-inherit">
                                  <div
                                    id="firstColumn"
                                    className="col-span-3 p-6"
                                  >
                                    <div className="flex items-center justify-between mb-4">
                                      <div className="section-title">
                                        {LocaleStrings.kAssignTicketsText}
                                      </div>
                                    </div>

                                    {/* Assign tickets */}
                                    <AssignTickets
                                      formHasError={assignedFormHasError}
                                      // ticketassignflow={ticketassignflow}
                                    />
                                  </div>

                                  {renderOrderDetails()}
                                </div>
                              ) : currentStep === "session" ? (
                                <div className="mx-auto md:grid grid-cols-5 min-h-inherit">
                                  <div
                                    id="firstColumn"
                                    className="col-span-3 p-6"
                                  >
                                    <div className="flex items-center justify-between mb-4">
                                      <div className="section-title">
                                        {LocaleStrings.kSessionRSVPSectionDesc}
                                      </div>
                                    </div>

                                    {/* Mark session as RSVP */}
                                    <AssignRSVPSessions />
                                  </div>

                                  {renderOrderDetails()}
                                </div>
                              ) : currentStep === "payment" ? (
                                <>
                                  <form>
                                    <div className="mx-auto md:grid grid-cols-5 min-h-inherit">
                                      <div
                                        id="firstColumn"
                                        className="col-span-3 p-6"
                                      >
                                        {showExpresssLogin ? (
                                          <ExpressLogin
                                            onCompletion={(e) =>
                                              expressCheckoutCompletion(e)
                                            }
                                          />
                                        ) : (
                                          ""
                                        )}

                                        <div className="flex items-center justify-between mb-4">
                                          <div className="section-title">
                                            {LocaleStrings.kBuyerInfoText}
                                          </div>
                                        </div>

                                        {/* Buyer Info */}
                                        <BuyerInfo
                                          disableFields={disableFields}
                                          isProposalTicket={isProposalTicket}
                                          selfAssign={selfAssign}
                                          ticketNav={ticketNav}
                                          formValues={formValues}
                                          autofill={props.autofill}
                                        />
                                      </div>

                                      {renderOrderDetails()}
                                    </div>
                                  </form>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="content-body flex items-center justify-center flex-col space-y-2">
                      <TicketIconOutline className="text-secondary w-20 h-20 rotate-135" />

                      {ticketArray?.error ? (
                        <div className="no-content-text">
                          {ticketArray?.error?.code ===
                          "invalid_proposal_responseid"
                            ? LocaleStrings.kInvalidAbstractResIdText
                            : ticketArray?.error?.code ===
                              "response_not_shortlisted"
                            ? LocaleStrings.kAbstractResNotShortlistedText
                            : ticketArray?.error?.code === "already_registered"
                            ? LocaleStrings.kAbstractResAlreadyRegText
                            : ticketArray?.error?.code ===
                              "organizer_credit_limit_used"
                            ? LocaleStrings.kHostCreditLimitUsedText
                            : LocaleStrings.kTicketNotAvailableText}
                        </div>
                      ) : (
                        <div className="no-content-text">
                          {LocaleStrings.kTicketNotAvailableText}
                        </div>
                      )}
                    </div>
                  )}
                </>
              ) : (
                <div className="content-body">
                  <Loader />
                </div>
              )}
            </>
          ) : (
            <div className="content-body flex items-center justify-center flex-col space-y-2">
              <TicketIconOutline className="text-secondary w-20 h-20 rotate-135" />

              <div className="no-content-text">
                {LocaleStrings.kTicketNotLiveText}
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="content-body">
          <Loader />
        </div>
      )}
    </>
  );
};

const validate = (values, ownProps) => {
  // console.log("values :- ", values);

  let errors = {};
  let pResponseData = ownProps?.pResponseData; // Proposal response data. Proposal ticket
  let manageTicketsCount = ownProps?.manageTicketsCount ?? []; // Selected ticket to buy
  let eventSettingsData = ownProps?.eventSettingsData?.data ?? {}; // Event settings
  let eventUserCategories = ownProps?.eventUserCategories?.data ?? []; // Event user categories
  // console.log("manageTicketsCount :- ", manageTicketsCount);
  // console.log("eventUserCategories :- ", eventUserCategories);

  let customEventSettings = JSON.parse(
    eventSettingsData?.custom_settings ?? "{}"
  );

  // Check buyer additional company info mandatory or not
  let madatoryAdditionalFields = false;
  if (
    customEventSettings?.showticketbuyermorefields &&
    customEventSettings?.mandatorybuyeradditionalinfo
  ) {
    madatoryAdditionalFields = true;
  }
  let ticketAssignFlow =
    ownProps.clientbuildno < 7 ? eventSettingsData?.ticketassignflow ?? "" : ""; // Ticket assign flow
  let showRefundPolicy = eventSettingsData?.showrefundpolicy ?? true; // Check setting to show refund policy or not
  let checkHasChild = _.filter(manageTicketsCount, (obj) => obj?.haschild); // Check any associated child ticket available in order

  // Script to display or hide selfassign checkbox start
  let groupTicketsArr = _.filter(manageTicketsCount, (o) => {
    return o?.noofchildtickets;
  });
  let generalTicketsArr = _.filter(manageTicketsCount, (o) => {
    return o?.type !== "addon";
  });
  let totalGeneralTickets = _.sumBy(generalTicketsArr, function (o) {
    return o?.quantity;
  });
  let addonTicketsArr = _.filter(manageTicketsCount, (o) => {
    return o?.type === "addon";
  });
  let totalAddonTickets = _.sumBy(addonTicketsArr, function (o) {
    return o?.quantity;
  });

  let name = values["name"];
  let email = values["email"];
  let additionalemail = values["additionalemail"];
  let isinvoice = values["isinvoice"];
  // let vat = values["vat"];
  let company_name = values["company_name"];
  let street = values["street"];
  let city = values["city"];
  let postal = values["postal"];
  let country = values["country"];
  let refund_policy = values["refund_policy"];
  let terms = values["terms"];
  let assign_himself = values["assign_himself"];
  if (email) {
    email = email.trim();
  }

  if (!name || name.trim() === "") {
    errors["name"] = LocaleStrings.kFieldRequired;
  }
  if (!email || email.trim() === "") {
    errors["email"] = LocaleStrings.kFieldRequired;
  } else if (email && !validateEmail(email)) {
    errors["email"] = LocaleStrings.kInvalidEmail;
  } else if (
    email &&
    !_.isEmpty(pResponseData) &&
    (ownProps.clientbuildno > 6 ? ownProps.assignflow : ticketAssignFlow) !==
      "beforepayment" &&
    pResponseData?.email !== email
  ) {
    // allow only submited email for the proposal.
    errors[`email`] = LocaleStrings.kAbstractResEmailChangeRestrictText;
  } else if (
    assign_himself &&
    email &&
    totalGeneralTickets === 1 &&
    (groupTicketsArr?.length === 0 || totalAddonTickets > 0)
  ) {
    // Logic to validate email domain which are whitelisted
    let selectedTicket = generalTicketsArr[0];
    let tCategory = selectedTicket?.usercategory ?? 0;

    let check = _.filter(
      eventUserCategories,
      (o) =>
        parseInt(o.id) === parseInt(tCategory) &&
        o?.allowemaildomain &&
        o?.allowemaildomain !== ""
    );
    let allowedEmailDomain =
      check?.length > 0 ? check[0].allowemaildomain.trim() : "";
    // console.log("allowedEmailDomain :- ", allowedEmailDomain);

    if (allowedEmailDomain !== "") {
      let emailDomain = email?.split("@")?.[1];
      let domainArray = allowedEmailDomain.split(",");
      // console.log("emailDomain :- ", emailDomain);
      // console.log("domainArray :- ", domainArray);
      if (!_.includes(domainArray, emailDomain)) {
        errors["email"] = _.replace(
          LocaleStrings.kInvalidEmailDomainText,
          "###DOMAIN###",
          emailDomain
        );
      }
    }
  }
  if (additionalemail) {
    let splitEmail = additionalemail.split(",");
    let invalidAdditionalEmail = [];
    splitEmail.forEach((val) => {
      let addemail = val.trim();
      if (!validateEmail(addemail)) {
        invalidAdditionalEmail.push(addemail);
      }
    });
    if (invalidAdditionalEmail.length > 0) {
      let emails = invalidAdditionalEmail.join(", ");

      errors["additionalemail"] = _.replace(
        LocaleStrings.kInvalidEmailsText,
        "###EMAILS###",
        emails
      );
    }
    // if (email && _.includes(splitEmail, email)) {
    //   errors["additionalemail"] =
    //     LocaleStrings.kAdditionalEmailsHasPrimaryEmailValidity;
    // }
  }
  if (
    checkHasChild?.length > 0 &&
    (!company_name || company_name.trim() === "")
  ) {
    errors["company_name"] = LocaleStrings.kFieldRequired;
  }
  if (madatoryAdditionalFields && !isinvoice) {
    errors["isinvoice"] = LocaleStrings.kFieldRequired;
  }
  if (isinvoice) {
    if (
      checkHasChild?.length === 0 &&
      (!company_name || company_name.trim() === "")
    ) {
      errors["company_name"] = LocaleStrings.kFieldRequired;
    }
    if (!street || street.trim() === "") {
      errors["street"] = LocaleStrings.kFieldRequired;
    }
    if (!city || city.trim() === "") {
      errors["city"] = LocaleStrings.kFieldRequired;
    }
    if (!postal || postal.trim() === "") {
      errors["postal"] = LocaleStrings.kFieldRequired;
    }
    if (!country || country.trim() === "") {
      errors["country"] = LocaleStrings.kFieldRequired;
    }
  }
  if (showRefundPolicy && !refund_policy) {
    errors["refund_policy"] = LocaleStrings.kFieldRequired;
  }
  if (!terms) {
    errors["terms"] = LocaleStrings.kFieldRequired;
  }

  // console.log("errors :- ", errors);
  return errors;
};

const mapStateToProps = (state) => {
  let pResponseData = state?.ticketLists?.responsedata ?? {}; // Proposal response data. Proposal ticket
  let init = { currentstep: "ticket" };
  if (!_.isEmpty(pResponseData)) {
    init.name = pResponseData?.firstname + " " + pResponseData?.lastname;
    init.email = pResponseData?.email;

    init = { ...init };
  }
  if (state?.eventSettingsData?.data) {
    let customEventSettings = JSON.parse(
      state?.eventSettingsData?.data?.custom_settings ?? "{}"
    );

    // Check buyer additional company info mandatory or not
    if (
      customEventSettings?.showticketbuyermorefields &&
      customEventSettings?.mandatorybuyeradditionalinfo
    ) {
      init.isinvoice = true;
    }
  }
  // console.log("init :- ", state.eventData);
  // console.log({ test: state.assignflow });

  return {
    session: state.session,
    eventData: state.eventData,
    eventSettingsData: state.eventSettingsData,
    initialValues: init,
    ticketArray: state.ticketLists,
    stripeCharges: state.stripeChargesData,
    manageTicketsCount: state.manageTicketsCount,
    promoApplied: state.promoApplied,
    assignedAttendeeTickets: state.assignedAttendeeTickets,
    pResponseData,
    eventUserCategories: state.eventUserCategories,
    formValues: getFormValues("TicketBuyerInfoForm")(state),
    assignflow: state.assignflow,
    clientbuildno: state.eventData?.clients_by_clientidfk?.buildno,
    // formErrors: state?.form?.["TicketBuyerInfoForm"]?.syncErrors ?? {},
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      clearTickets,
      fetchTickets,
      fetchEventUserCategories,
      fetchStripeCharges,
      fetchStripeConnection,
      manageTicketCount,
      cancelPromo,
      updateTicketAssignedAttendee,
      updateTicketAssignedError,
      palceTicketOrder,
      fetchEventInterests,
      fetchAppuserCount,
      clearOrderData,
      updateAssignFlow,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    form: "TicketBuyerInfoForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(Tickets)
);
